import { Box, LinearProgress, Paper, Stack, Typography } from "@mui/material";

export default function Splash() {
    return (
        <Paper
            sx={{
                position: "fixed",
                width: 200,
                height: 200,
                top: "calc(50% - 100px)",
                left: "calc(50% - 100px)",
                overflow: "hidden",
            }}
        >
            <Stack alignItems="center" sx={{ height: "100%" }} spacing={2}>
                <img
                    width={100}
                    height={100}
                    src="/images/logo_default.svg"
                    style={{ marginTop: "20px" }}
                />

                <Typography>پنل کاربری پرشین سازه</Typography>

                <Box flexGrow={1} />

                <Box sx={{ width: "100%" }}>
                    <LinearProgress />
                </Box>
            </Stack>
        </Paper>
    );
}
